import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import './G2-forgot-password.scss';

class G2ForgotPassword extends Component {
	state = {
		email: '',
		validate: {
			email: true,
			password: true,
		},
		emailPassword: true,
		responseMessage: null,
		error: null,
		waiting: false,
	}

	componentDidMount() {
		document.addEventListener('keydown', this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown = (event) => {
		if (event.keyCode === 13) {
			this.onSubmit(event);
		}
	}

	onClick = (event) => {
		const { emailPassword } = this.state;
		event.preventDefault();
		this.setState({ emailPassword: !emailPassword });
	}

	onChange = (event, type) => {
		const valid = this.onValidate(event.target.value, type);
		const { validate } = this.state;

		this.setState({
			[type]: event.target.value,
			validate: {
				...validate,
				[type]: valid,
			},
		});
	}

	onSubmit = (event) => {
		const { email } = this.state;
		const validEmail = this.onValidate(email, 'email');

		event.preventDefault();
		this.setState({ validate: { email: validEmail }, error: null });
		if (!validEmail) return;

		/* PAYLOAD SENT TO FORGET PASSWORD ENDPOINT
			{
				emailAddress: <String>,
			}
		*/
		this.onResponse(this.onRequest({
			emailAddress: email,
		}));
	}

	onResponse = (response) => {
		this.setState({ waiting: true });

		const { emailPassword } = this.state;
		// Based on what kind of response is received this is where we add
		// either success or fail functionality
		response
			.then((data) => {
				this.setState({ waiting: false });

				const { success, message } = data;
				if (success && emailPassword) {
					this.setState({
						responseMessage: message,
					});
				} else if (!success && emailPassword) {
					this.setState({
						error: message,
					});
				} else if (success && !emailPassword) { // I think this state is unnecessary now as the password hint has been removed.
					this.setState({
						responseMessage: message,
					});
				} else if (!success && !emailPassword) {
					this.setState({
						error: message,
					});
				}
			})
			.catch((error) => {
				this.setState({
					waiting: false,
					error,
				});
			});
	}

	async onRequest(payload) {
		try {
			const response = await this.postPayload(payload);
			return response;
		} catch (error) {
			return error;
		}
	}

	postPayload = (payload) => {
		const { emailPassword } = this.state;
		const { data } = this.props;
		const { endpoints } = data;
		const endpoint = endpoints.forgotPassword;

		return fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		}).then((response) => {
			return response.json();
		});
	}

	onValidate = (value, rule) => {
		let isValid = true;

		if (rule === 'email') {
			const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
			isValid = pattern.test(value) && isValid;
		}

		return isValid;
	}

	render() {
		const {
			email,
			validate,
			emailPassword,
			error,
			responseMessage,
			waiting,
		} = this.state;

		const {
			callbacks,
			formId,
			data,
		} = this.props;

		const {
			backButtonLabel,
			emailLabel,
			formCopy,
			formTitle,
			passwordLabel,
			radio01,
			radio02,
			invalidEmailText,
			sendSuccessCopy,
		} = data;

		const emailValid = !validate.email ? 'u-show' : null;
		const showError = error ? 'u-show' : null;
		const buttonText = emailPassword ? radio01.buttonLabel : radio02.buttonLabel;
		const emailPass = emailPassword ? 'u-active' : null;

		let submitButton = (
			<a href="/customer-center" className="btn btn--primary btn--inverted G2-forgot-password__button" onClick={this.onSubmit}>
				{buttonText}
			</a>
		);

		if (waiting) {
			submitButton = (
				<a href="/" className="btn btn--primary btn--inverted G2-forgot-password__button" onClick={(event) => { event.preventDefault(); }}>
					<div className="loading">
						<div className="loading__dots">Loading...</div>
					</div>
				</a>
			);
		}

		let form = (
			<Fragment>
				<h2 className="G2-forgot-password__title">{formTitle}</h2>
				<p className="G2-forgot-password__copy">{formCopy}</p>
				<div className="G2-forgot-password__control">
					<label className="G2-forgot-password__label" htmlFor={`email-${formId}`}>{emailLabel}</label>
					<div className="G2-forgot-password__input-wrapper">
						<input
							id={`email-${formId}`}
							name="email"
							className="G2-forgot-password__input"
							type="text"
							value={email}
							onChange={(event) => { this.onChange(event, 'email'); }}
						/>
					</div>
					<p className={['G2-forgot-password__error', emailValid].join(' ')}>
						<span className="G2-forgot-password__error-cross" />
						{invalidEmailText}
					</p>
				</div>
				<div className="G2-forgot-password__control">
					<label className="G2-forgot-password__label">{passwordLabel}</label>
					<div className="G2-forgot-password__radio-wrapper">
						<a
							href="/customer-center"
							className={['G2-forgot-password__radio', emailPass].join(' ')}
							onClick={this.onClick}
						>
							<span className="G2-forgot-password__radio-text">{radio01.label}</span>
						</a>
					</div>
				</div>
				<div className="G2-forgot-password__control">
					<a href="/" className="G2-forgot-password__label u-normal-weight btn btn--secondary btn--link" onClick={(event) => { callbacks.click(event, 'login', true); }} >
						<span className="btn__arrow-angle" />
						{backButtonLabel}
					</a>
				</div>
				<div className="G2-forgot-password__control-submit">
					{submitButton}
				</div>
			</Fragment>
		);

		if (responseMessage && emailPassword) {
			form = (
				<Fragment>
					<div className="G2-forgot-password__control">
						<p className="G2-forgot-password__success">
							{sendSuccessCopy}
							&nbsp;
							{email}
						</p>
						<p className="G2-forgot-password__message">
							{responseMessage}
						</p>
					</div>
					<div className="G2-forgot-password__control">
						<a href="/" className="G2-forgot-password__label u-normal-weight btn btn--secondary btn--link" onClick={(event) => { callbacks.click(event, 'login', true); }} >
							<span className="btn__arrow-angle" />
							{backButtonLabel}
						</a>
					</div>
				</Fragment>
			);
		}

		if (responseMessage && !emailPassword) {
			form = (
				<Fragment>
					<div className="G2-forgot-password__control">
						<p className="G2-forgot-password__success">
							{email}
						</p>
						<p className="G2-forgot-password__message">
							{responseMessage}
						</p>
					</div>
					<div className="G2-forgot-password__control">
						<a href="/" className="G2-forgot-password__label u-normal-weight btn btn--secondary btn--link" onClick={(event) => { callbacks.click(event, 'login', true); }} >
							<span className="btn__arrow-angle" />
							{backButtonLabel}
						</a>
					</div>
				</Fragment>
			);
		}

		return (
			<div className="G2-forgot-password__view">
				<form className="G2-forgot-password__form">
					{form}
				</form>
			</div>
		);
	}
}

G2ForgotPassword.propTypes = {
	formId: PropTypes.number,
	callbacks: PropTypes.shape({}),
	data: PropTypes.shape({}).isRequired,
};

G2ForgotPassword.defaultProps = {
	formId: Math.floor(Math.random() * 10000000000000000),
	callbacks: {},
};

export default G2ForgotPassword;
